var SCM = SCM || {};

(function (ns, $) {

    // ----------------------------
    // Support functions
    // ----------------------------

    ns.init = function () {
        if ($('.pg_article').length) {
            ns.trackArticlePageEvents();
        }
        if ($('.pg_ChapterStandard').length) {
            ns.trackBookPageEvents();
        }
    };

    // check if an anchor is an external link
    function isExternalLink(anchor) {
        var pageHN = location.hostname;  // we previously grabbed location.host until NARN-7840
        var anchorHN = anchor.hostname;

        return anchorHN.length > 0 && anchorHN != pageHN;
    }

    // ----------------------------
    // Generic event
    // ----------------------------

    // send a named event to the Scholarly iQ tracker.
    //
    // * See "The Scholarly iQ guide to working with page tags" for a discussion of the API calls you can use.
    ns.trackOnPageEvent = function (ev) {
        var event = 'ev=' + encodeURIComponent(ev);

        if (typeof ntptEventTag !== 'undefined') {
            ntptEventTag(event);
        }
    };

    ns.trackRelatedLinkEvent = function () {
        var event = 'event_type=RELATEDLINKS';

        if (typeof ntptEventTag !== 'undefined') {
            ntptEventTag(event);
        }
    };


    // ----------------------------
    // Self serve page tracking
    // ----------------------------

    // register event tracking
    ns.trackSelfServePageEvents = function () {
        var $doc = $(document);

        // NARN-7840: support external links on self serve pages
        $doc.on('click', '.widget-SelfServeContent a', function () {
            var anchor = $(this).get(0);

            // only track external links
            if (isExternalLink(anchor)) {
                ns.trackOnPageEvent('self-serve-external-link-' + $(this).attr('href'));
            }
        });
    };

    // ----------------------------
    // Article page tracking
    // ----------------------------

    // register event tracking
    ns.trackArticlePageEvents = function () {
        var $doc = $(document);
        // pdf
        $doc.on('click', 'a.article-pdfLink', function () {
            ns.trackOnPageEvent('article-pdf');         
        });

        // split-view
        $doc.on('click', '.st-split-view', function () {
            ns.trackOnPageEvent('article-view-split-view');
        });

        // standard-view
        $doc.on('click', 'a.standard-view', function () {
            ns.trackOnPageEvent('article-view-standard-view');
        });

        // view
        $doc.on('click', 'li.article-content-filter', function () {
            ns.trackOnPageEvent('article-view-' + $(this).attr('data-content-filter'));
        });

        // toolbox alerts
        $doc.on('click', '#Toolbar .toolboxGetAlertsWidget', function () {
            ns.trackOnPageEvent('article-alerts');
        });

        // email article
        $doc.on('click', '#Sidebar .widget-alerts .getAlertsLink', function () {
            ns.trackOnPageEvent('article-email-alerts-' + $(this).text());
        });

        // Share
        $doc.on('click', 'ul.addthis_toolbox > li > a', function () {
            ns.trackOnPageEvent('article-share-' + $(this).attr('title'));
        });

        // Tools
        $doc.on('click', 'ul#ToolsDrop > li > div.widget', function () {
            var ev = null;
            if ($(this).hasClass('widget-ToolboxGetCitation')) {
                ev = 'article-tools-GetCitation';
            }
            else if ($(this).hasClass('widget-ToolboxPermissions')) {
                ev = 'article-tools-GetPermission';
            }
            ns.trackOnPageEvent(ev);
        });

        // citation links
        $doc.on('click', '#getCitation.reveal-modal ul > li > a', function () {
            ns.trackOnPageEvent('article-tools-GetCitation-' + $(this).text());
        });

        // author link is handled by the main click event since it will block other events

        $doc.on('click', '.info-card-author .info-card-search a', function () {
            ns.trackOnPageEvent('article-author-search-' + $(this).text());
        });

        // section nav
        $doc.on('click', '.widget-ArticleJumpLinks .section-jump-link .scrollTo', function () {
            ns.trackOnPageEvent('article-section-link-' + $(this).text());
        });

        // view large fig
        $doc.on('click', '.fig-section .fig-link, .fig-section .fig-view-orig', function () {
            ns.trackOnPageEvent('article-figure-view-' + $(this).closest('.fig-section').attr('data-id'));
        });

        // download fig
        $doc.on('click', '.fig-section .download-slide', function () {
            ns.trackOnPageEvent('article-figure-download-' + $(this).closest('.fig-section').attr('data-id'));
        });

        // download all figs
        $doc.on('click', '.st-download-images-ppt', function () {
            ns.trackOnPageEvent('article-figure-download-all');
        });

        // supplements
        $doc.on('click', '.widget-ArticleDataSupplements .dataSuppLink', function () {
            ns.trackOnPageEvent('article-data-supplement-' + $(this).href);
        });

        $doc.on('click', '.widget-ArticleTopInfo .citation-doi a, .widget-ArticleFulltext a, .widget-RelatedPubMed a', function () {
            var anchor = $(this).get(0);

            // only track external links
            if (isExternalLink(anchor))
            {
                if ($(this).parents('.citation-links').length) { // PubMed, Google Scholar, etc.
                    ns.trackOnPageEvent('article-external-link-' + $(this).text());
                }
                else {
                    ns.trackOnPageEvent('article-external-link-' + $(this).attr('href'));
                }
            }
        });

        // article history
        $doc.on('click', '.st-article-history', function () {
            ns.trackOnPageEvent('article-history');
        });

        // article metrics
        $doc.on('click', '#Sidebar .widget-ArticleLevelMetrics .artmet-modal-trigger', function () {
            ns.trackOnPageEvent('article-metrics');
        });

        // cited by
        $doc.on('click', '#Sidebar .widget-ArticleCitedBy .article-cited-link-wrap a', function () {
            ns.trackOnPageEvent('article-citation-' + $(this).text());
        });

    };

    ns.trackBookPageEvents = function () {
        var $doc = $(document);
        // pdf
        $doc.on('click', '.widget-BookChapterMainView a.article-pdfLink', function () {
            // NARN-12168, reasoning for this change:
            // * Change to NTPT_PGEXTRA only happens upon click event of a chapter PDF download
            // * Values within NTPT_PGEXTRA are all set upon a chapter page load (Search for NTPT_PGEXTRA in HTML of chapter page)
            // * Click event will replace "event_type" to desired type, "full-text.pdf"
            // * Pressing back from the loaded chapter PDF page will reload the NTPT_PGEXTRA and display correct type
            NTPT_PGEXTRA = NTPT_PGEXTRA.replace('event_type=full-text', 'event_type=full-text.pdf');
            ns.trackOnPageEvent('full-text.pdf');
        });

        $doc.on('click', '.js-seeAlso-link', function () {
            ns.trackRelatedLinkEvent();
        });

        // download chapter fig
        $doc.on('click', '.fig-section .download-slide', function () {
            ns.trackOnPageEvent('chapter-figure-download-' + $(this).closest('.fig-section').attr('data-id'));
        });
    };

    // ----------------------------
    // Book page tracking
    // ----------------------------

})(SCM.ScholarlyiQ = SCM.ScholarlyiQ || {}, jQuery);